import conditionsRepository from '@/repositories/conditions.repository';
import { useQuery } from '@tanstack/react-query';

export function useGetCondition(conditionId: string) {
  return useQuery({
    queryKey: ['conditions', 'get', conditionId],
    queryFn: () => conditionsRepository.getCondition(conditionId),
  });
}
